<template>
  <section
    class="relative py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 overflow-hidden bg-gradient-to-br from-[#f4f4f4] via-[#f8f9fa] to-[#e9ecef]"
  >
    <!-- Removed dark overlay and changed main background -->

    <!-- Animated shapes - adjusted for light background -->
    <div class="absolute inset-0 overflow-hidden">
      <div
        class="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-[#fe6d0d]/10 to-transparent rounded-full blur-3xl animate-pulse"
      ></div>
      <div
        class="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-[#ffb47c]/10 to-transparent rounded-full blur-3xl animate-pulse animation-delay-2000"
      ></div>
    </div>

    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 relative z-10">
      <header class="text-center mt-20 sm:mb-12 md:mb-16" data-aos="fade-down">
        <h1
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] via-[#ffb47c] to-[#0b105d] mb-4 sm:mb-6 animate-gradient"
        >
          {{ $t('aboutUsPage.title') }}
        </h1>
        <!-- <div
          class="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white/70 rounded-full border border-[#ffb47c]/50 backdrop-blur-sm shadow-md"
        >
          <div class="w-2 h-2 sm:w-3 sm:h-3 bg-green-500 rounded-full animate-pulse"></div>

          <p
            class="text-lg sm:text-xl md:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ff8c42]"
          >
            {{ $t('magicSaaS.deepTech') }}
          </p>
        </div> -->
      </header>
    </div>
  </section>
</template>

<script setup lang="ts"></script>

<style scoped>
.animate-gradient {
  background-size: 200% 200%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.animation-delay-2000 {
  animation-delay: 2s;
}
</style>
